import { useEffect } from 'react';
import { toast } from 'sonner';
import { markSessionExpired } from '@/entities/session/api/mark-session-expired';
import { refreshProfile } from '@/entities/session/api/refresh-profile';
import { t } from '@/shared/i18n/t';
import { replica } from '@/shared/sync/replica';

/** Start the sync loop for the page's lifetime and tell the person what the server refused. */
export function useBackgroundSync(): void {
  useEffect(function startSync() {
    const stop = replica.engine.start();
    const stopRejections = replica.engine.onRejections(function notify(rejections) {
      for (const rejection of rejections) {
        toast.warning(
          rejection.code === 'sync.record_deleted'
            ? t(
                'A change of yours was not applied: someone had deleted the record. You can restore it from the trash.',
              )
            : t('The server refused a change: {message}', { message: rejection.message }),
          { duration: 10_000 },
        );
      }
    });
    const stopState = replica.engine.subscribe(function followState() {
      const { status } = replica.engine.getState();
      if (status === 'unauthorized') markSessionExpired();
      if (status === 'idle') void refreshProfile().catch(() => undefined);
    });
    void navigator.storage?.persist?.();
    return () => {
      stop();
      stopRejections();
      stopState();
    };
  }, []);
}
